/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_u3m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Three minutes in fully boiling water gives a soft-boiled egg with a fully set white and a still-liquid, warm yolk. For a slightly firmer but still runny yolk, 4 minutes is common; 6 to 7 minutes gets you a jammy, fully firm yolk.`)
};

const es_timer_u3m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tres minutos en agua en pleno hervor dan un huevo pasado por agua con la clara totalmente cuajada y la yema tibia y aún líquida. Para una yema un poco más firme pero aún líquida, 4 minutos es habitual; de 6 a 7 minutos obtienes una yema cremosa y totalmente firme.`)
};

const de_timer_u3m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drei Minuten in voll kochendem Wasser ergeben ein weichgekochtes Ei mit vollständig festem Eiweiß und noch flüssigem, warmem Dotter. Für einen etwas festeren, aber noch flüssigen Dotter sind 4 Minuten üblich; 6 bis 7 Minuten ergeben einen sämigen, vollständig festen Dotter.`)
};

const nl_timer_u3m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drie minuten in volledig kokend water geeft een zachtgekookt ei met een volledig gestold eiwit en een nog vloeibare, warme dooier. Voor een iets steviger maar nog steeds lopende dooier is 4 minuten gangbaar; 6 tot 7 minuten geeft je een romige, volledig vaste dooier.`)
};

const fr_timer_u3m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trois minutes dans une eau à pleine ébullition donnent un œuf mollet au blanc entièrement pris et au jaune encore liquide et chaud. Pour un jaune un peu plus ferme mais toujours coulant, 4 minutes sont courantes ; 6 à 7 minutes donnent un jaune crémeux et entièrement ferme.`)
};

const it_timer_u3m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre minuti in acqua in piena ebollizione danno un uovo alla coque con l'albume completamente rappreso e il tuorlo ancora liquido e caldo. Per un tuorlo leggermente più sodo ma ancora liquido, 4 minuti sono comuni; 6-7 minuti danno un tuorlo cremoso e completamente sodo.`)
};

const pt_br2_timer_u3m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três minutos em água em fervura plena resultam em um ovo com a clara totalmente firme e a gema ainda líquida e quente. Para uma gema um pouco mais firme, mas ainda mole, 4 minutos é comum; 6 a 7 minutos resultam em uma gema cremosa e totalmente firme.`)
};

const pt_timer_u3m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três minutos em água em fervura plena dão um ovo escalfado com a clara totalmente firme e a gema ainda líquida e quente. Para uma gema ligeiramente mais firme mas ainda líquida, 4 minutos é comum; 6 a 7 minutos dão uma gema cremosa e totalmente firme.`)
};

const ja_timer_u3m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完全に沸騰したお湯で3分ゆでると、白身が完全に固まり黄身がまだ液状で温かい半熟卵になります。もう少し固めながらもとろみを残したい場合は4分が一般的で、6〜7分でとろっと濃厚な完全に固まった黄身になります。`)
};

const zh_timer_u3m_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在完全沸腾的水中煮3分钟，蛋白完全凝固，蛋黄仍呈温热流动状。若想要略微凝固但仍带流动感的蛋黄，通常煮4分钟；煮6到7分钟则能得到浓稠、完全凝固的溏心蛋黄。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_u3m_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_u3m_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_u3m_faq3_a", locale)
	if (locale === "en") return en_timer_u3m_faq3_a(inputs)
	if (locale === "es") return es_timer_u3m_faq3_a(inputs)
	if (locale === "de") return de_timer_u3m_faq3_a(inputs)
	if (locale === "nl") return nl_timer_u3m_faq3_a(inputs)
	if (locale === "fr") return fr_timer_u3m_faq3_a(inputs)
	if (locale === "it") return it_timer_u3m_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_timer_u3m_faq3_a(inputs)
	if (locale === "pt") return pt_timer_u3m_faq3_a(inputs)
	if (locale === "ja") return ja_timer_u3m_faq3_a(inputs)
	return zh_timer_u3m_faq3_a(inputs)
};